module.exports = __webpack_public_path__ + "media/images/front/doctor_identity_verification_request/sample_hpki_card-d2d3d68b0b8b64756b8ec049c8140acd.png";